module.exports = __webpack_public_path__ + "static/media/seguridad_ciudaddana_8.51289af2.png";